import { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useTypes } from "./hooks/useFirebase";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import SiteFooter from "./components/SiteFooter";
import AdminView from "./components/AdminView";

function AppInner() {
  const [adminOpen, setAdminOpen] = useState(false);
  const { user } = useAuth();
  const { types, loading, addType, deleteType } = useTypes();

  return (
    <div style={{ minHeight: "100vh", background: "#fff" }}>
      <Nav onAdminOpen={() => setAdminOpen(true)} />

      <Hero />
      <Marquee />
      <About />
      <Projects types={types} loading={loading} />
      <Contact />
      <SiteFooter />

      {/* Admin overlay panel */}
      {adminOpen && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(10,10,10,0.65)", zIndex: 1000, display: "flex", justifyContent: "flex-end" }}
          onClick={() => setAdminOpen(false)}
        >
          <div
            style={{ width: "min(800px, 100%)", height: "100%", background: "#fff", overflowY: "auto", borderLeft: "1px solid var(--ink)" }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: "1px solid var(--line)", position: "sticky", top: 0, background: "#fff", zIndex: 10 }}>
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted)" }}>// Admin Panel</span>
              <button
                onClick={() => setAdminOpen(false)}
                style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "11px", letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--muted)", border: "1px solid var(--line)", padding: "6px 12px", background: "#fff", cursor: "pointer" }}
              >
                Close ×
              </button>
            </div>
            {user ? (
              <AdminView types={types} onAddType={addType} onDeleteType={deleteType} />
            ) : (
              <div style={{ padding: "40px 24px" }}>
                <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--muted)" }}>// Use the Staff button in the nav to sign in.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
